import tw, { styled } from 'twin.macro';

import MarkdownHeading1 from './MarkdownHeading1';

const MarkdownHeading2 = styled(MarkdownHeading1)`
  ${tw`text-2xl py-2`}

  .message-type-markdown & {
    ${tw`py-0 border-b-0 m-0`}
  }
`;

export default MarkdownHeading2;
